import { render } from "./Journals.vue?vue&type=template&id=0b6388b8&scoped=true"
import script from "./Journals.vue?vue&type=script&lang=js"
export * from "./Journals.vue?vue&type=script&lang=js"

import "./Journals.vue?vue&type=style&index=0&id=0b6388b8&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6388b8"]])

export default __exports__